import { useEffect, useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { getDataAPI, postDataAPI } from "../utils/fetchData";
import Adminnavbar from "./adminnavbar";
import Footer from "./footer";
import LoginRequest from "./loginRequest";
import Sidenavbar from "./sidenav";

const CONTAINER_STYLE = { backgroundColor: "#ffffff", padding: "30px" };
const TABLE_HEADER_STYLE = {
	backgroundColor: "rgb(167, 213, 136)",
	fontSize: "15px",
	fontWeight: "700",
	letterSpacing: "0.5px",
	textAlign: "center",
};
const CELL_STYLE = {
	fontSize: "18px",
	textAlign: "center",
	fontFamily: "Roboto, sans-serif",
};
const DELETE_BUTTON_STYLE = {
	background: "#E23F1C",
	fontSize: "13px",
	borderRadius: "4px",
	border: "none",
	color: "#fff",
};

const CourseCategoryManagement = () => {
	const { auth } = useSelector((state) => state);
	const dispatch = useDispatch();

	// Modal state
	const [show, setShow] = useState(false);
	const [showSub, setShowSub] = useState(false);
	const [showEdit, setShowEdit] = useState(false);
	const [showEditSub, setShowEditSub] = useState(false);
	// Edit state
	const [editCategory, setEditCategory] = useState(null);
	const [editName, setEditName] = useState("");
	const [editDescription, setEditDescription] = useState("");
	const [editOrder, setEditOrder] = useState("");
	const [editSubcategory, setEditSubcategory] = useState(null);
	const [editSubName, setEditSubName] = useState("");
	const [editSubDescription, setEditSubDescription] = useState("");
	const [editSubOrder, setEditSubOrder] = useState("");
	// Edit category handler
	const handleEditCategory = (cat) => {
		setEditCategory(cat);
		setEditName(cat.name);
		setEditDescription(cat.description);
		setEditOrder(cat.order);
		setShowEdit(true);
	};

	const handleUpdateCategory = async (e) => {
		e.preventDefault();
		// if (!editName) return setNameError("Name is required");
		let valid = true;
		setNameError("");
		setOrderError("");

		if (!editName) {
			setNameError("Name is required");
			valid = false;
		}
		if (!editOrder || isNaN(editOrder)) {
			setOrderError("Order is required and must be a number");
			valid = false;
		}

		if (!valid) return;
		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
		try {
			const res = await postDataAPI(
				"updatecoursecategory",
				{
					id: editCategory.id,
					name: editName,
					description: editDescription,
					order: editOrder,
				},
				auth.token
			);
			if (res.status === 200) {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { success: res.data.msg },
				});
				setCategories((prev) =>
					prev.map((c) =>
						c.id === editCategory.id
							? {
									...c,
									name: editName,
									description: editDescription,
									order: editOrder,
							  }
							: c
					)
				);
				setShowEdit(false);
				setEditCategory(null);
				setEditName("");
				setEditDescription("");
				setEditOrder("");
			}
		} catch (err) {
			setNameError(err.response?.data?.msg || "Error updating category");
		}
	};

	// Edit subcategory handler
	const handleEditSubcategory = (sub) => {
		setEditSubcategory(sub);
		setEditSubName(sub.name);
		setEditSubDescription(sub.description);
		setEditSubOrder(sub.order);
		setShowEditSub(true);
	};

	const handleUpdateSubcategory = async (e) => {
		e.preventDefault();
		// if (!editSubName) return setSubNameError("Name is required");
		let valid = true;
		setSubNameError("");
		setSubOrderError("");

		if (!editSubName) {
			setSubNameError("Name is required");
			valid = false;
		}
		if (!editSubOrder || isNaN(editSubOrder)) {
			setSubOrderError("Order is required and must be a number");
			valid = false;
		}

		if (!valid) return;
		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
		try {
			const res = await postDataAPI(
				"updatecoursesubcategory",
				{
					id: editSubcategory.id,
					name: editSubName,
					description: editSubDescription,
					order: editSubOrder,
				},
				auth.token
			);
			if (res.status === 200) {
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { success: res.data.msg },
				});
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
				setSubcategories((prev) =>
					prev.map((s) =>
						s.id === editSubcategory.id
							? {
									...s,
									name: editSubName,
									description: editSubDescription,
									order: editSubOrder,
							  }
							: s
					)
				);
				setShowEditSub(false);
				setEditSubcategory(null);
				setEditSubName("");
				setEditSubDescription("");
				setEditSubOrder("");
			}
		} catch (err) {
			setSubNameError(err.response?.data?.msg || "Error updating subcategory");
		}
	};

	// Form state
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	const [order, setOrder] = useState("");
	const [categoryId, setCategoryId] = useState("");
	const [subName, setSubName] = useState("");
	const [subDescription, setSubDescription] = useState("");
	const [subOrder, setSubOrder] = useState("");

	// Data state
	const [categories, setCategories] = useState([]);
	const [subcategories, setSubcategories] = useState([]);

	// Error state
	const [nameError, setNameError] = useState("");
	const [orderError, setOrderError] = useState("");
	const [subNameError, setSubNameError] = useState("");
	const [subOrderError, setSubOrderError] = useState("");

	// Fetch categories
	useEffect(() => {
		const fetchCategories = async () => {
			try {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
				const res = await getDataAPI("getcoursecategory", auth.token);
				setCategories(res.data.categories || []);
				console.log("res.data.categories", res.data.categories);
			} catch (err) {
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { error: "Failed to fetch categories" },
				});
			} finally {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
			}
		};
		fetchCategories();
	}, [dispatch, auth.token]);

	// Fetch subcategories for selected category
	useEffect(() => {
		if (!categoryId) return setSubcategories([]);
		const fetchSubcategories = async () => {
			try {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
				const res = await getDataAPI(
					`getcoursesubcategory/${categoryId}`,
					auth.token
				);
				setSubcategories(res.data.subcategories || []);
			} catch (err) {
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { error: "Failed to fetch subcategories" },
				});
			} finally {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
			}
		};
		fetchSubcategories();
	}, [categoryId, dispatch, auth.token]);

	// Add category with validation
	const handleAddCategory = async (e) => {
		e.preventDefault();
		let valid = true;
		setNameError("");
		setOrderError("");

		if (!name) {
			setNameError("Name is required");
			valid = false;
		}
		if (!order || isNaN(order)) {
			setOrderError("Order is required and must be a number");
			valid = false;
		}

		if (!valid) return;
		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
		try {
			const res = await postDataAPI(
				"createcoursecategory",
				{ name, description, order },
				auth.token
			);
			if (res.status === 200) {
				setCategories((prev) => [...prev, res.data.category]);
				setShow(false);
				setName("");
				setDescription("");
				setOrder("");
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { success: res.data.msg },
				});
			}
		} catch (err) {
			setNameError(err.response?.data?.msg || "Error adding category");
		}
	};

	// Add subcategory
	const handleAddSubcategory = async (e) => {
		e.preventDefault();
		setSubNameError("");
		// if (!subName) return setSubNameError("Name is required");
		let valid = true;
		setSubNameError("");
		setSubOrderError("");

		if (!subName) {
			setSubNameError("Name is required");
			valid = false;
		}
		if (!subOrder || isNaN(subOrder)) {
			setSubOrderError("Order is required and must be a number");
			valid = false;
		}

		if (!valid) return;
		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
		try {
			const res = await postDataAPI(
				"createcoursesubcategory",
				{
					name: subName,
					description: subDescription,
					order: subOrder,
					categoryid: categoryId,
				},
				auth.token
			);
			if (res.status === 200) {
				setSubcategories((prev) => [...prev, res.data.subcategory]);
				setShowSub(false);
				setSubName("");
				setSubDescription("");
				setSubOrder("");
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { success: res.data.msg },
				});
			}
		} catch (err) {
			setSubNameError(err.response?.data?.msg || "Error adding subcategory");
		}
	};

	// Delete category (set isactive to false)
	const handleDeleteCategory = async (cat) => {
		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
		try {
			const res = await getDataAPI(
				`inactivecoursecategory/${cat.id}`,
				auth.token
			);
			if (res.status === 200) {
				setCategories((prev) => prev.filter((c) => c.id !== cat.id));
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { success: res.data.msg },
				});
			}
		} catch (err) {
			alert("Error deleting category");
		}
	};

	// Delete subcategory (set isactive to false)
	const handleDeleteSubcategory = async (sub) => {
		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
		try {
			const res = await getDataAPI(
				`inactivecoursesubcategory/${sub.id}`,
				auth.token
			);
			if (res.status === 200) {
				setSubcategories((prev) =>
					prev.map((s) => (s.id === sub.id ? { ...s, isactive: false } : s))
				);
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { success: res.data.msg },
				});
			}
		} catch (err) {
			alert("Error deleting subcategory");
		}
	};

	if (!auth.user) return <LoginRequest />;

	return (
		<>
			<Adminnavbar />
			<div style={CONTAINER_STYLE}>
				<div className="button-format">
					<div className="dashboard-text">Course Category Management</div>
					<button className="addinstructor-btn" onClick={() => setShow(true)}>
						+ ADD CATEGORY
					</button>
					<Modal show={show} onHide={() => setShow(false)}>
						<Modal.Header closeButton>
							<Modal.Title>Add Category</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<form onSubmit={handleAddCategory}>
								<input
									type="text"
									value={name}
									placeholder="Category Name"
									onChange={(e) => setName(e.target.value)}
									className="form-control"
								/>
								{nameError && <div className="text-danger">{nameError}</div>}
								<input
									type="number"
									value={order}
									placeholder="Order"
									onChange={(e) => setOrder(e.target.value)}
									className="form-control mt-2"
								/>
								{orderError && <div className="text-danger">{orderError}</div>}
								<textarea
									value={description}
									placeholder="Description"
									onChange={(e) => setDescription(e.target.value)}
									className="form-control mt-2"
								/>

								<Button type="submit" className="mt-3" variant="success">
									Add
								</Button>
							</form>
						</Modal.Body>
					</Modal>
				</div>
				<div className="row format">
					<Sidenavbar />
					<div className="col-8">
						<Table>
							<thead id="pl">
								<tr style={TABLE_HEADER_STYLE}>
									<th>S.No</th>
									<th>Name</th>
									<th>Order</th>
									<th>Description</th>
									{/* <th>Status</th> */}
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								{categories.length === 0 ? (
									<tr>
										<td colSpan="5" style={{ textAlign: "center" }}>
											No categories available
										</td>
									</tr>
								) : (
									categories.map((cat, idx) => (
										<tr key={cat.id}>
											<td style={CELL_STYLE}>{idx + 1}</td>
											<td style={CELL_STYLE}>{cat.name}</td>
											<td style={CELL_STYLE}>{cat.order}</td>
											<td style={CELL_STYLE}>{cat.description}</td>
											{/* <td style={CELL_STYLE}>
												{cat.isactive === 0 ? "Inactive" : "Active"}
											</td> */}
											<td style={CELL_STYLE}>
												<Button
													style={DELETE_BUTTON_STYLE}
													className="btn btn-danger mt-2"
													onClick={() => handleDeleteCategory(cat)}
													disabled={cat.isactive === 0}>
													<i className="fa fa-trash" aria-hidden="true"></i>
												</Button>
												<Button
													className="btn btn-secondary mt-2 ms-2"
													onClick={() => handleEditCategory(cat)}
													disabled={cat.isactive === 0}>
													<i className="fa fa-edit" aria-hidden="true"></i> Edit
												</Button>
												<Button
													className="btn btn-primary mt-2 ms-2"
													onClick={() => {
														setCategoryId(cat.id);
														setShowSub(true);
													}}>
													Manage Subcategories
												</Button>
											</td>
										</tr>
									))
								)}
							</tbody>
						</Table>
					</div>
				</div>
				{/* Subcategory Modal */}
				<Modal show={showSub} size="lg" onHide={() => setShowSub(false)}>
					<Modal.Header closeButton>
						<Modal.Title>Manage Subcategories</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<form onSubmit={handleAddSubcategory}>
							<input
								type="text"
								value={subName}
								placeholder="Subcategory Name"
								onChange={(e) => setSubName(e.target.value)}
								className="form-control"
							/>
							{subNameError && (
								<div className="text-danger">{subNameError}</div>
							)}
							<input
								type="number"
								value={subOrder}
								placeholder="Order"
								onChange={(e) => setSubOrder(e.target.value)}
								className="form-control mt-2"
							/>
							{subOrderError && (
								<div className="text-danger">{subOrderError}</div>
							)}
							<textarea
								value={subDescription}
								placeholder="Description"
								onChange={(e) => setSubDescription(e.target.value)}
								className="form-control mt-2"
							/>

							<Button type="submit" className="mt-3" variant="success">
								Add Subcategory
							</Button>
						</form>
						<Table className="mt-4">
							<thead>
								<tr>
									<th>S.No</th>
									<th>Name</th>
									<th>Order</th>
									<th>Description</th>
									{/* <th>Status</th> */}
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								{subcategories.length === 0 ? (
									<tr>
										<td colSpan="5" style={{ textAlign: "center" }}>
											No subcategories available
										</td>
									</tr>
								) : (
									subcategories.map((sub, idx) => (
										<tr key={sub.id}>
											<td style={CELL_STYLE}>{idx + 1}</td>
											<td style={CELL_STYLE}>{sub.name}</td>
											<td style={CELL_STYLE}>{sub.order}</td>
											<td style={CELL_STYLE}>{sub.description}</td>
											{/* <td style={CELL_STYLE}>
												{sub.isactive === false ? "Inactive" : "Active"}
											</td> */}
											<td style={CELL_STYLE}>
												<Button
													style={DELETE_BUTTON_STYLE}
													className="btn btn-danger mt-2"
													onClick={() => handleDeleteSubcategory(sub)}
													disabled={sub.isactive === false}>
													<i className="fa fa-trash" aria-hidden="true"></i>
												</Button>
												<Button
													className="btn btn-secondary mt-2 ms-2"
													onClick={() => handleEditSubcategory(sub)}
													disabled={sub.isactive === false}>
													<i className="fa fa-edit" aria-hidden="true"></i> Edit
												</Button>
											</td>
										</tr>
									))
								)}
							</tbody>

							{/* Edit Subcategory Modal */}
							<Modal
								show={showEditSub}
								size="lg"
								onHide={() => {
									setShowEditSub(false);
									setSubNameError("");
									setSubOrderError("");
								}}>
								<Modal.Header closeButton>
									<Modal.Title>Edit Subcategory</Modal.Title>
								</Modal.Header>
								<Modal.Body>
									<form onSubmit={handleUpdateSubcategory}>
										<input
											type="text"
											value={editSubName}
											placeholder="Subcategory Name"
											onChange={(e) => setEditSubName(e.target.value)}
											className="form-control"
										/>
										{subNameError && (
											<div className="text-danger">{subNameError}</div>
										)}
										<input
											type="number"
											value={editSubOrder}
											placeholder="Order"
											onChange={(e) => setEditSubOrder(e.target.value)}
											className="form-control mt-2"
										/>
										{subOrderError && (
											<div className="text-danger">{subOrderError}</div>
										)}
										<textarea
											value={editSubDescription}
											placeholder="Description"
											onChange={(e) => setEditSubDescription(e.target.value)}
											className="form-control mt-2"
										/>
										<Button type="submit" className="mt-3" variant="success">
											Update
										</Button>
									</form>
								</Modal.Body>
							</Modal>
						</Table>
					</Modal.Body>
				</Modal>
				{/* Edit Category Modal */}
				<Modal show={showEdit} onHide={() => setShowEdit(false)}>
					<Modal.Header closeButton>
						<Modal.Title>Edit Category</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<form onSubmit={handleUpdateCategory}>
							<input
								type="text"
								value={editName}
								placeholder="Category Name"
								onChange={(e) => setEditName(e.target.value)}
								className="form-control"
							/>
							{nameError && <div className="text-danger">{nameError}</div>}
							<input
								type="number"
								value={editOrder}
								placeholder="Order"
								onChange={(e) => setEditOrder(e.target.value)}
								className="form-control mt-2"
							/>
							{orderError && <div className="text-danger">{orderError}</div>}
							<textarea
								value={editDescription}
								placeholder="Description"
								onChange={(e) => setEditDescription(e.target.value)}
								className="form-control mt-2"
							/>

							<Button type="submit" className="mt-3" variant="success">
								Update
							</Button>
						</form>
					</Modal.Body>
				</Modal>
			</div>
			<Footer />
		</>
	);
};

export default CourseCategoryManagement;
